export enum AgreementType {
  COURTESY_VEHICLE = 'AGREEMENT_TYPE_COURTESY_VEHICLE',
  INSURANCE_CLAIM = 'AGREEMENT_TYPE_INSURANCE_CLAIM'
}
